import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export function UpgradeNotice({ text, testid = "upgrade-notice" }) {
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50/70 p-4 flex items-start gap-3 text-sm text-amber-800" data-testid={testid}>
      <Lock className="h-4 w-4 mt-0.5 shrink-0" />
      <div>
        <p>{text}</p>
        <Link to="/dashboard/billing" className="font-semibold underline hover:no-underline" data-testid={`${testid}-link`}>Passa a un piano a pagamento</Link>
      </div>
    </div>
  );
}
